import React, { useEffect, useState } from "react";
import "./App.css";
import Main from "./containers/Main";
import ArenaLabPage from "./containers/arenaLabPage/ArenaLabPage";

function App() {
  const [currentPage, setCurrentPage] = useState("home");

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "/arena-lab" || hash === "arena-lab") {
        setCurrentPage("arena-lab");
        document.title = "ARENA Lab - Embodied AI Research at SMU";
        // Update meta description for SEO
        let metaDescription = document.querySelector("meta[name='description']");
        if (!metaDescription) {
          metaDescription = document.createElement("meta");
          metaDescription.name = "description";
          document.head.appendChild(metaDescription);
        }
        metaDescription.content = "ARENA Lab - Embodied AI and Robotics Research Laboratory at Singapore Management University. Explore our research on robot learning, navigation, and human-robot interaction.";
      } else {
        setCurrentPage("home");
        document.title = "Linh Kästner - Robotics & AI Researcher";
        let metaDescription = document.querySelector("meta[name='description']");
        if (!metaDescription) {
          metaDescription = document.createElement("meta");
          metaDescription.name = "description";
          document.head.appendChild(metaDescription);
        }
        metaDescription.content = "Portfolio of Linh Kästner, Assistant Professor at Singapore Management University, specializing in embodied AI, robotics, and autonomous navigation.";
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange(); // Check initial hash

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  return (
    <div>
      {currentPage === "arena-lab" ? (
        <ArenaLabPage />
      ) : (
        <Main />
      )}
    </div>
  );
}

export default App;
